module.exports = __webpack_public_path__ + "static/media/5.028948d4.png";